export var EventBus = {
    on: function (event, handler) {
        document.addEventListener(event, handler);
    },
    off: function (event, handler) {
        document.removeEventListener(event, handler);
    },
    emit: function (event, detail) {
        document.dispatchEvent(new CustomEvent(event, { bubbles: true, detail: detail }));
    },
};
